function MeshPage() {
    /**
     *
     */
    MeshPage.prototype.initialize = function (console, mesh) {
        this.id = "mesh";
        this.console = console;
        this.mesh = mesh;

        return this;
    };

    /**
     *
     */
    MeshPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.consoleService
            .getMesh(this.mesh)
            .done(
                function (mesh) {
                    Mesh.bind(this.console.deviceTypes, mesh);

                    this.mesh = mesh;

                    this.console.connectMesh(this.mesh);

                    // Concurrently load Node states

                    for (var n in this.mesh.nodes) {
                        this.console.consoleService.getNode(this.mesh.nodes[n], this.mesh).done(function (node) {
                            this.page.mesh.nodes[this.index].state = node.state;
                            this.page.mesh.nodes[this.index]._lastConfigurationTimestamp = node.lastModificationTimestamp;
                            this.page.mesh.nodes[this.index].firmwareVersion = node.firmwareVersion;

                            this.page.console.safeApply();
                        }.bind({page: this, index: n})).fail(function (error) {
                            console.error(error);
                        }.bind(this));
                    }

                    this.console.consoleService.getTasks(this.mesh).done(function (tasks) {
                        this.taskCount = tasks.length;

                        this.console.safeApply();
                    }.bind(this)).fail();

                    this.tiles = [];

                    if (this.console.consoleService.settings.display.showTasks) {
                        var tile = {
                            label: 'Tasks', icon: 'sl-setting-gears-2',
                            select: function () {
                                this.console.pushToDoPage(this.mesh)
                            }.bind(this)
                        };

                        this.console.consoleService.getTasks(this.mesh).done(function (tasks) {
                            this.tile.itemCount = tasks.length;
                            this.page.console.safeApply();
                        }.bind({page: this, tile: tile})).fail();

                        this.tiles.push(tile);
                    }

                    if (this.console.consoleService.settings.display.showCommunication) {
                        var tile = {
                            label: 'Communication', icon: 'sl-bubble-conversation-5',
                            select: function () {
                                this.console.pushCommunicationPage(this.mesh)
                            }.bind(this)
                        };

                        tile.itemCount = Math.round(Math.random() * 10);
                        tile.interval = window.setInterval(function () {
                            this.tile.itemCount = Math.round(Math.random() * 10);

                            this.page.console.safeApply();
                        }.bind({page: this, tile: tile}), 120000);

                        this.tiles.push(tile);
                    }

                    if (this.console.consoleService.settings.display.showWiki) {
                        this.tiles.push({
                            label: 'Wiki', icon: 'sl-text-wrapping-1',
                            select: function () {
                                this.console.pushWikiPage(this.mesh)
                            }.bind(this)
                        });
                    }

                    for (var n in this.mesh.nodes) {
                        for (var m in this.mesh.nodes[n].groups) {
                            if (!this.console.hasAnyEntitlements(this.mesh.nodes[n].groups[m])) {
                                continue;
                            }

                            var tile = {
                                label: this.mesh.nodes[n].groups[m].label,
                                icon: this.mesh.nodes[n].groups[m].icon,
                                select: function () {
                                    this.page.console.pushGroupPage(this.group);
                                }.bind({page: this, group: this.mesh.nodes[n].groups[m]})
                            };

                            this.tiles.push(tile);
                        }
                    }

                    this.console.safeApply();

                    deferred.resolve();
                }.bind(this)).fail(function (error) {
            this.console.consoleService.logError("Cannot show Mesh Page" + error);

            deferred.reject(error);
        }.bind(this));

        return deferred.promise();
    };

    /**
     *
     */
    MeshPage.prototype.leave = function () {
    };

    /**
     *
     */
    MeshPage.prototype.isPhotoFlow = function (flow) {
        for (var n in flow.events) {
            if (flow.events[n].family === "startEvent" && flow.events[n].eventType === "photo") {
                return true;
            }
        }

        return false;
    };
}
